import { asc, eq } from 'drizzle-orm'
import { db } from '@/db'
import { users, tenantMemberships } from '@/db/schema'
import { requireExpertUser } from '@/lib/role-guard'
import UsersClient from './UsersClient'

export default async function AdminUsersPage() {
  const expert = await requireExpertUser()

  const rows = await db
    .select({
      id: users.id,
      email: users.email,
      displayName: users.displayName,
      role: tenantMemberships.role,
      isActive: tenantMemberships.isActive,
      authProvider: users.authProvider,
      lastLoginAt: users.lastLoginAt,
      createdAt: users.createdAt,
    })
    .from(users)
    .innerJoin(tenantMemberships, eq(tenantMemberships.userId, users.id))
    .where(eq(tenantMemberships.tenantId, expert.tenantId))
    .orderBy(asc(users.email))

  const serialized = rows.map((r) => ({
    ...r,
    lastLoginAt: r.lastLoginAt?.toISOString() ?? null,
    createdAt: r.createdAt.toISOString(),
  }))

  return (
    <main className="min-h-screen bg-zinc-50 px-4 py-10 text-zinc-950 dark:bg-zinc-950 dark:text-zinc-100">
      <div className="mx-auto max-w-3xl space-y-6">
        <div>
          <h1 className="text-2xl font-semibold text-zinc-950 dark:text-white">Users</h1>
          <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">
            Manage team members. Invited users can sign in with their email via the magic-link or Google SSO.
          </p>
        </div>
        <UsersClient initialUsers={serialized} currentUserId={expert.id} />
      </div>
    </main>
  )
}
